<template>
    <div class="result-page page-container" v-if="current">
        <div class="search-container">
            <Search
                :searching="false"
            />
        </div>
        <div
            class="loading-wrap"
            v-if="current.total === 0 && loading"
        >
            <img src="@/assets/loading.png"/>
            <span>正在搜索…</span>
        </div>
        <div class="empty-wrap"
            v-else-if="current.articles.length === 0"
        >
            <img src="@/assets/empty.png"/>
            <p>啊哦～没有找到结果…</p>
            <p>您可以换个词试试，或来这里<span class="feedback" @click="feedback">吐个槽</span>～</p>
        </div>
        <ul
            class="list-container"
            v-else
        >
            <li
                v-for="(item, index) in current.articles"
                :key="index"
                class="list-item"
                @click="() => handleJumpLink(item, index)"
            >
                <p class="title">{{item.title}}</p>
                <p class="text" v-html="item.highlight.content_text ? item.highlight.content_text.join('') : item.content_text"></p>
                <p class="company">来源：{{item.highlight['sources.name'] ? item.highlight['sources.name'].join('') : item.highlight['sources.name']}}</p>
            </li>
            <li
                class="load-more"
                @click="getArticles"
                v-if="current.curPage < current.totalPage"
            >
                <p>查看更多<i v-if="loading">...</i></p>
            </li>
        </ul>
    </div>
</template>

<script>
// components
import Search from '@/components/Search'
// mixin
import feedbackMixin from '@/mixins/feedback'
// methods
import { sleep } from '@/methods/util'
import { env } from '@/methods/env'

import { createNamespacedHelpers, mapMutations as mapRootMutation } from 'vuex'
const { mapState, mapActions, mapGetters, mapMutations } = createNamespacedHelpers('result')

export default {
    components: {
        Search
    },
    mixins: [feedbackMixin],
    computed: {
        ...mapState({
            loading: state => state.loading,
            t: state => state.t
        }),
        ...mapGetters([
            'current',
        ])
    },
    methods: {
        ...mapActions([
            'initFromStorage',
            'getArticles'
        ]),
        ...mapMutations([
            'addArticles'
        ]),
        async handleJumpLink ({ id, url, app_article_id, can_search }, index) {
            const {
                query: {
                    w = ''
                } = {}
            } = this.$route
            const {
                curPage,
                total,
                sid
            } = this.current
            await this.$http.post(`/idun/search/statistics`, {
                wd: w,
                page: curPage,
                size: 10,
                total: total,
                id,
                position: index + 1,
                project: 'guokr',
                sid: sid
            })
            if (app_article_id && can_search) {
                const host = env.isProd ? 'guokrapp.guokr.com' : 'guokrapp-test00.guokr.cn'
                window.location.href = `https://${host}/article/${app_article_id}`
            } else {
                window.location.href = url
            }
        },
    },
    mounted () {
        this.initFromStorage(this.$route.query)
        if (!this.current.articles.length) {
            this.getArticles()
        }
    }
}
</script>

<style lang="less" scoped>
@keyframes RotateAnim {
    from {
        transform: rotateZ(0deg);
    }
    to {
        transform: rotateZ(360deg);
    }
}
.result-page {
    display: flex;
    flex-direction: column;
    .search-container {
        padding: 15px;
        border-bottom: 8px solid #F2F2F2;
    }
    .empty-wrap {
        font-size: 14px;
        color: #B2B2B2;
        .feedback {
            color: #0C88BA;
            position: relative;
            &::before {
                content: ' ';
                display: block;
                position: absolute;
                width: 150%;
                height: 28px;
                left: -25%;
                top: -5px;
            }
        }
        img {
            margin-top: 55px;
            width: 49px;
        }
    }
    .loading-wrap {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
            width: 30px;
            animation: RotateAnim 2s infinite;
        }
        span {
            margin: 5px 0 0 10px;
            line-height: 24px;
            font-size: 15px;
            color: rgba(74, 74, 74, 0.50);
        }
    }
    .list-container {
        li {
            padding: 15px;
            &.list-item {
                text-align: left;
                border-bottom: 8px solid #F2F2F2;
                .title {
                    font-size: 18px;
                    line-height: 27px;
                    color: #0C88BA;
                    margin-bottom: 10px;
                }
                .text {
                    font-size: 14px;
                    line-height: 20px;
                    color: #444;
                    margin-bottom: 10px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    word-break: break-all;
                    /deep/ strong {
                        color: #15AA00;
                        font-weight: normal;
                    }
                }
                .company {
                    font-size: 14px;
                    line-height: 18px;
                    color: #B2B2B2;
                }
            }
            &.load-more {
                color: #0C88BA;
                font-size: 14px;
                line-height: 18px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Result/index.vue